import type { TErrorLogInsertDTO } from './errorLog.dto';

import type { TErrorLogEntry } from './errorLog.types';

const toErrorLogDTO = (entry: TErrorLogEntry): TErrorLogInsertDTO => ({
  action: entry.action,
  entity_kind: entry.entityKind,
  entity_id: entry.entityID,
  code: entry.code,
  message: entry.message,
  source: entry.source,
  route: entry.route,
  stack: entry.stack,
  release: entry.release,
  user_agent: entry.userAgent,
});

export {
  toErrorLogDTO,
};
